import { getIsBetslipLoaded } from "../../store/state/betslip-module/betslip-module-selectors";
import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { AlertProps } from "@ppb/the-wall-common/types";
import { MapStateToPropsFactory } from "react-redux";
import { createMultiplesNotificationsSelector, translateMultiple } from "../connected-sportsbook-betslip-mapper";
import { createGetConfirmationOneLineMultiple, createIsConfirmStep } from "../sportsbook-betslip-confirm-mapper";
import { createGetCurrentMultiple } from "../SportsbookPlace/sportsbook-place-mapper";

type CardProps = {
  multiplesNotifications?: AlertProps[];
  currentMultiple?: { id: string; text: string };
};

export type StateProps = CardProps | Record<string, never>;

export type ContainerProps = {
  hasOneLineMultiple: boolean;
  shouldFocusStakeField?: boolean;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, BetslipApplicationState> = () => {
  const buildMultiplesNotifications = createMultiplesNotificationsSelector();
  const getCurrentMultiple = createGetCurrentMultiple();
  const getConfirmMultiple = createGetConfirmationOneLineMultiple();
  const getIsConfirmStep = createIsConfirmStep();

  return (appState: BetslipApplicationState, { hasOneLineMultiple }: ContainerProps): StateProps => {
    const isBetslipLoaded = getIsBetslipLoaded(appState);
    const multiplesNotifications = buildMultiplesNotifications(appState);

    let currentMultiple;
    if (hasOneLineMultiple) {
      const isConfirmStep = getIsConfirmStep(appState);
      currentMultiple = isConfirmStep ? getConfirmMultiple(appState) : getCurrentMultiple(appState);
    }

    if (!isBetslipLoaded || !(currentMultiple || multiplesNotifications)) {
      return {};
    }

    return {
      multiplesNotifications,
      currentMultiple: currentMultiple
        ? {
            id: currentMultiple.id,
            text: translateMultiple(currentMultiple?.betType),
          }
        : undefined,
    };
  };
};
